import { HTMLAttributes, PropsWithChildren } from 'react';
import './PageLayout.scss';

interface Props {
  rightColumn?: JSX.Element;
  className?: string;
  top?: JSX.Element;
}

const PageLayout = ({
  children,
  rightColumn,
  className = '',
  top,
  ...rest
}: PropsWithChildren<Props & HTMLAttributes<HTMLDivElement>>) => {
  return (
    <div className={`Page ${className}`} {...rest}>
      <div className='container'>
        {top}
        {rightColumn ? (
          <div className='row PageLayout__row'>
            <div className='col-12 col-lg-8 flex-grow-1 PageLayout__leftColumn'>
              {children}
            </div>
            <div className='col-12 col-lg-4 PageLayout__rightColumn'>
              {rightColumn}
            </div>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default PageLayout;
